"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNREGISTERED = exports.ON_TIME = exports.LATE = exports.EARLY = void 0;
exports.EARLY = 'early';
exports.LATE = 'late';
exports.ON_TIME = 'on-time';
exports.UNREGISTERED = 'unregistered';
